module.exports = __webpack_public_path__ + "img/resource-tech-image-27.6efdf704.jpg";